import { LightningCssLoader } from './loader'

export default LightningCssLoader
